import { render, staticRenderFns } from "./Booking5.vue?vue&type=template&id=7f86a4b0&"
import script from "./Booking5.vue?vue&type=script&lang=ts&"
export * from "./Booking5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports